import { jsx } from 'react/jsx-runtime';
import { EmeraldDividerCoreInputs } from '@emerald/nxcore';

class EmeraldDividerInputs extends EmeraldDividerCoreInputs {}

const EmeraldDivider = props => {
  return jsx("div", {
    className: "emerald-divider",
    children: props.vertical ? jsx("div", {
      className: `vertical-divider ${props.isWhite ? 'isWhite' : ''} ${props.allowMargin ? 'allowMargin' : ''}`,
      title: props.title
    }) : jsx("hr", {
      className: `horizontal-divider ${props.isWhite ? 'isWhite' : ''} ${props.allowMargin ? 'allowMargin' : ''}`,
      title: props.title
    })
  });
};
EmeraldDivider.defaultProps = new EmeraldDividerInputs();
EmeraldDivider.displayName = 'EmeraldDivider';

export { EmeraldDivider, EmeraldDividerInputs };
